export default {
  pt: {
    'layout.appShell.mainNavigation': 'Navegação principal',
  },
  en: {
    'layout.appShell.mainNavigation': 'Main navigation',
  },
  es: {
    'layout.appShell.mainNavigation': 'Navegación principal',
  },
}
